import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import 'chartjs-adapter-date-fns';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const DataBlockNumber = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiUrl = 'https://rebekah.cloud/api/network_data/';

  // Fetch data from the API
  const fetchData = async () => {
    try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const result = await response.json();
      setData(result.data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
  };

  // Get the most recent entry
  const mostRecent = data.length > 0 ? data[data.length - 1] : null;

  const labels = data.map(entry => formatDate(entry.timestamp));
  const blockNumberData = data.map(entry => entry.block_number);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Block Number',
        data: blockNumberData,
        borderColor: 'red',
        backgroundColor: 'rgba(0, 255, 0, 0.2)',
        fill: true,
      },
    ],
  };

  const chartOptions = {
    scales: {
      x: {
        type: 'category',
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Block Number',
        },
      },
    },
  };

  return (
    <div>
      {/* Display most recent block number and timestamp above the chart */}
      {mostRecent && (
        <div style={{ marginBottom: '20px' }}>
          <p><strong>Most Recent Block Number:</strong> {mostRecent.block_number}</p>
          <p><strong>Timestamp:</strong> {formatDate(mostRecent.timestamp)}</p>
        </div>
      )}
      <Line data={chartData} options={chartOptions} />
    </div>
  );
};

export default DataBlockNumber;
